import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TokenStorageService } from './core/services/token-storage.service';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly tokenStorage = inject(TokenStorageService);

  get isLoggedIn(): boolean {
    return this.tokenStorage.isAdminLoggedIn();
  }
}
